module.exports = "https://static.wmbcdn.com/uniweb/images/0203a253fc5182d7003ba03b3cdf1ff9.svg";